import useStores from 'shared/hooks/use-stores';
import { useObserver } from 'mobx-react-lite';
import { useEffect, useState } from 'react';

type CheckoutLineItem = { type: string; value: number };

type UseCheckoutLineItemsOptions = {
  // When false, the hook stays unconditionally called but reads no active-cart MobX state and returns a stable
  // empty list, so callers with explicit (non-cart) context are never re-rendered by active-cart changes.
  enabled?: boolean;
};

const NO_LINE_ITEMS: CheckoutLineItem[] = [];

export function useCheckoutLineItems({ enabled = true }: UseCheckoutLineItemsOptions = {}): CheckoutLineItem[] {
  const { Cart } = useStores();
  const isCalculating: boolean = useObserver(() => (enabled ? Cart.isCalculating : false));
  const checkoutLineItems: CheckoutLineItem[] = useObserver(() => (enabled ? Cart.checkoutLineItems : NO_LINE_ITEMS));

  const [lineItemData, setLineItemData] = useState(checkoutLineItems);

  useEffect((): void => {
    if (enabled) {
      setLineItemData(checkoutLineItems);
    }
  }, [enabled, isCalculating, checkoutLineItems]);

  return enabled ? lineItemData : NO_LINE_ITEMS;
}
